module.exports = __webpack_public_path__ + "img/LEGEND_THREE_A1010.c579aaf0.png";